import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { closeModal } from "../../../libs/modals";
import {
  BULK_CREATE_POST_MEDIA_SELECT_MODAL,
  openBulkCreatePostModal,
} from "./bulk-create-post.actions";
import { MediaPicker } from "../../media-library/components/media-picker/media-picker";
import { useDispatch } from "react-redux";
import { ButtonIcon, Tooltip } from "@dialogueconsulting/sked-ui";
import { CreatePostRequest, PostCloseBehavior } from "./bulk-create-post.types";
import { convertCollectionFileToPostMediaFile } from "../../media-library/convert-collection-file-to-post-media-file";
import { useRef } from "react";
import { Post } from "../types";
import { PostFormState } from "../../../shared/types/post";
import { RequiredU } from "../../../types/utils";
import { useTrackEvent } from "../../../libs/analytics";
import { SELECTED_MEDIA_FROM_LIBRARY_BULK } from "../../../constants/Events";
export interface MediaSelectModalProps {
  initialTab?: string;
  post?: Partial<Post>;
  postCloseBehavior?: PostCloseBehavior;
  form?: Partial<PostFormState>;
}
export const MediaSelectModal = ({
  initialTab,
  post,
  postCloseBehavior,
  form,
}: MediaSelectModalProps) => {
  const dispatch = useDispatch();
  const closeThisModal = (
    requests: RequiredU<Omit<CreatePostRequest, "formTitle">>[]
  ) => {
    dispatch(closeModal({ type: BULK_CREATE_POST_MEDIA_SELECT_MODAL }));
    dispatch(openBulkCreatePostModal({ requests, postCloseBehavior }));
  };
  const tooltipContainerRef = useRef<HTMLDivElement>(null);
  const trackEvent = useTrackEvent();

  return (
    <ModalRoot
      show
      title="Select Create Posts"
      onHide={() => {
        closeThisModal([{ type: "create", post, form, assets: undefined }]);
      }}
    >
      <Modal.Body>
        <MediaPicker
          limit={post?.isStory && !post?.publishStoryManually ? 3 : 10}
          onClose={() => {
            closeThisModal([{ type: "create", post, form, assets: undefined }]);
          }}
          onSelect={async (files) => {
            // Handle file selection logic here
            console.log("Selected files:", files);
            closeThisModal([
              {
                type: "create",
                assets: files,
                post,
                form,
              },
            ]);
          }}
          selectedAccountIds={[]}
          initialTab={initialTab}
          renderCloseButton={() => {
            return (
              <div className="flex items-center gap-[8px]">
                <span className="block h-[17px] text-blue-500 text-[12px] font-semibold">
                  Skip
                </span>
              </div>
            );
          }}
          renderActionButtons={(files) => {
            return (
              <div ref={tooltipContainerRef}>
                <Tooltip
                  text="Bulk create multiple posts"
                  side="top"
                  contentClassName="w-[120px] text-[12px] leading-[16px] text-center"
                  container={tooltipContainerRef.current || undefined}
                >
                  <div>
                    <ButtonIcon
                      hierarchy="secondary"
                      onClick={() => {
                        closeThisModal(
                          files.map((file) => ({
                            type: "create",
                            assets: [
                              convertCollectionFileToPostMediaFile(file),
                            ],
                            post,
                            form,
                          }))
                        );
                        trackEvent({
                          eventName: SELECTED_MEDIA_FROM_LIBRARY_BULK,
                          metadata: { length: files.length },
                        });
                      }}
                      name="bulk-create-posts"
                      size="xs"
                      disabled={files.length <= 1}
                      className="disabled:bg-white disabled:shadow-none"
                    />
                  </div>
                </Tooltip>
              </div>
            );
          }}
        />
      </Modal.Body>
    </ModalRoot>
  );
};

const ModalRoot = styled(Modal)`
  // fixes for cross angular/react modals
  overflow-y: auto;
  z-index: 1041 !important;
  --modal-width: 806px;
  .modal-dialog {
    width: var(--modal-width);
    /* width: auto !important; */
    max-width: 1400px;

    .modal-body {
      padding-left: 0;
      padding-bottom: 0;
      margin-bottom: 0;
      padding-right: 0;
      padding-top: 0;
    }
  }
`;
